/**
 * 触发前端函数
 * rootStore
 * options:{alias} // 前端脚本参数
 */


export const invokeFeScript = function (_rootStore: any, options: any) {
  const { alias } = options;  
  const args = [...arguments]; 
  // const hookArgs = args.slice(2); 
  return _rootStore.designerScripts?.[alias]?.apply?.(this, args);
}